module.exports = "/_next/static/images/Coins@2x-1dcc78c2d4832ea4eba231894357abca.png";